import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { IsSAPAdmin } from "src/_helpers/utils";
import { Operator } from "../../../_models/operators";
import { AppService } from "src/_services/app.service";
@Component({
  selector: "mat-operator-search",
  templateUrl: "./operator-search.component.html",
  styleUrls: ["./operator-search.component.scss"],
})
export class OperatorSeachComponent implements OnInit {
  @Output() onUserSelection: EventEmitter<Operator> = new EventEmitter();
  @Output() onClear: EventEmitter<null> = new EventEmitter();

  searchUserName: string = "all";
  usersList: Operator[] = [];
  filterUsers: Operator[] = [];
  selectedUser = null;

  constructor(private appService: AppService) {}

  ngOnInit() {
    // this.getUsersList("");
  }

  getUsersList(query: string) {
    try {
      this.appService.getOperators(query).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.usersList = res.portalUsers;
          this.filterUsers = res.portalUsers;
        }
      });
    } catch (err) {}
  }

  onUserSearchHandler(key: string) {
    this.getUsersList(key);
    this.filterUsers = this.findOpion(key);
  }

  findOpion(value: string): Operator[] {
    // this.getUsersList(value);
    return this.usersList.filter((user) => user.UserName.includes(value));
  }

  onChangeUserSelection(event: any) {
    const user = this.filterUsers.filter((user: Operator) => {
      return user.OperatorId === event;
    });

    if (user) {
      this.onUserSelection.emit(user[0]);
    }
  }

  onCancelSearch() {
    this.selectedUser = null;
    this.onClear.emit(null);
  }
}
